import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  withIcon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  withIcon = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-300 rounded-sm tracking-wide';
  const variants = {
    primary: 'bg-[#C9A227] hover:bg-[#B08D1F] text-white shadow-md hover:shadow-lg border border-[#C9A227]',
    secondary: 'bg-[#3D2314] hover:bg-[#2A180D] text-[#FAF8F5] shadow-md hover:shadow-lg border border-[#3D2314]',
    outline: 'bg-transparent border-2 border-[#C9A227] text-[#3D2314] hover:bg-[#C9A227] hover:text-white'
  };
  const sizes = {
    sm: 'text-sm px-4 py-2',
    md: 'text-base px-6 py-3',
    lg: 'text-lg px-8 py-4'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-80">
      {children}
      {withIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-81" />}
    </motion.button>;
}